import { FunctionComponent } from "react"
import { Outlet } from "react-router-dom"

const AuthPage: FunctionComponent = () => {
  return <Outlet />
}

export default AuthPage